import React from "react";
import Skeleton from "@mui/material/Skeleton";
import fundIcon from "../assets/images/fund.svg";
import pensionfundsIcon from "../assets/images/pension-funds.svg";
import providentfundsIcon from "../assets/images/provident-funds.svg";
import insurancefundsIcon from "../assets/images/insurance-funds.svg";
import educationfundsIcon from "../assets/images/education-funds.svg";
import lifeinsuranceIcon from "../assets/images/life-insurance.svg";
import mortgageinsuranceIcon from "../assets/images/mortgage-insurance.svg";
import widowspensionIcon from "../assets/images/widows-pension.svg";
import orphansallowanceIcon from "../assets/images/orphans-allowance.svg";
import disabilityallowanceIcon from "../assets/images/disability-allowance.svg";

const LoadingPage = ({ onboardingStep }) => {
  return (
    <>
      <div class="loading_wrapper">
      <div class="loader" id="loader"></div>
      <div class="loader" id="loader2"></div>
      <div class="loader" id="loader3"></div>
      <div class="loader" id="loader4"></div>
      <span id="text">טעינה...</span>
      </div>
    </>
  );
};

export default LoadingPage;
